<template>
	<div class="help-link-container">
		<button
			type="button"
			class="help-link"
			title="Need Help? Contact Us."
			aria-label="Need Help? Contact Us."
			@click="$emit('contact')"
		>
			Need Help? Contact Us.
		</button>
	</div>
</template>

<script>

export default {
	name: 'OaoFooterHelpLink',
	emits: ['contact']
};

</script>

<style lang="scss" scoped>
.help-link-container {
	display: flex;
	justify-content: center;
	width: 100%;
}

.help-link {
	background: none;
	border: none;
	color: var(--primary);
	cursor: pointer;
	display: inline-block;
	font-size: 1.125rem;
	font-weight: 300;
	line-height: 1.4;
	margin: 0;
	padding: 0 0 0.2rem 0;
	text-align: center;
	text-decoration: none;
}

.help-link:after {
	display: block;
	content: '';
	border-bottom: solid 1px var(--primary);
	transform: scaleX(0);
	transition: transform 250ms ease-in-out;
}

.help-link:hover,
.help-link:focus {
	opacity: 1;
}

.help-link:hover:after,
.help-link:focus:after {
	transform: scaleX(1);
}

.help-link:focus-visible {
	outline: 2px solid var(--primary);
	outline-offset: 2px;
}
</style>
